import useCustomerCart from "../hooks/useCustomerCart";
import { getCartThemeComponent } from "./cart/themes/registry";

function CartPage() {
  const cart = useCustomerCart();
  const { loading, theme } = cart;

  if (loading) return <div className="min-h-screen bg-gray-50 p-4" dir="rtl"><div className="mx-auto mt-16 h-40 max-w-3xl animate-pulse rounded-2xl bg-gray-200" /></div>;

  const ThemeComponent = getCartThemeComponent(theme);
  return <ThemeComponent {...cart} />;
}

export default CartPage;
